export default __webpack_public_path__ + "static/media/bluetechblog.baa0ba63.png";